var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoundFilterList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    viewBox: "0 0 14 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.222 10h1.556a.835.835 0 000-1.667H6.222a.835.835 0 000 1.667zM0 .833a.809.809 0 00.778.833h12.444a.835.835 0 000-1.667H.778A.809.809 0 000 .833zm3.111 5h7.778a.835.835 0 000-1.667H3.111a.835.835 0 000 1.667z",
    fill: "#cdcdcd"
  })));
}

export default SvgIconRoundFilterList;